import React, { Component } from 'react';
import { Redirect, withRouter } from 'react-router';

import AccountSelectHyperlist from "./widgets/AccountSelectHyperlist";

import AccountBalancePanel from "./widgets/AccountBalancePanel"


export class StudentHome extends Component {
    static displayName = StudentHome.name;

    constructor(props) {
        super(props);


        props.store.updateBanner(`Welcome, ${props.store.user.studentName}!`)
        this.state = {
            showUncertifiedWarning: false,
            uncertifiedCount: 0
        };
        this.redirectToTarget = this.redirectToTarget.bind(this);
        this.closeWarningModal = this.closeWarningModal.bind(this);
        this.loadUncertifiedWarning = this.loadUncertifiedWarning.bind(this);
    }
    componentDidMount() {
        this.loadUncertifiedWarning();
    }


    async loadUncertifiedWarning() {
        try {
            const apiBase = process.env.REACT_APP_API_ENDPOINT || "/api/";
            const studentId = this.props.store.user.studentId;
            const url = `${apiBase}Timesheets/uncertified-warning?studentId=${studentId}`;

            const response = await fetch(url, {
                method: "GET",
                credentials: "include"
            });

            if (!response.ok) {
                return;
            }

            const data = await response.json();

            if (data && data.showWarning) {
                this.setState({
                    showUncertifiedWarning: true,
                    uncertifiedCount: data.uncertifiedCount || 0
                });
            } else {
                this.setState({
                    showUncertifiedWarning: false,
                    uncertifiedCount: 0
                });
            }
        } catch (error) {
            console.error("Could not load uncertified warning.", error);
        }
    }

    closeWarningModal() {
        this.setState({ showUncertifiedWarning: false });
    }
    // Redirect to the page where you select your timeslot.
    redirectToTarget(event) {
        console.log(event.target)
        this.props.history.push(`/student/${event.target.value}`);
    }
    renderWarningCard() {
        if (!this.state.showUncertifiedWarning) {
            return null;
        }

        return (
            <div className="alert alert-warning" style={{ marginBottom: "20px" }}>
                <h4 style={{ marginTop: 0 }}>Warning: Uncertified Timesheets</h4>
                <p style={{ marginBottom: "8px" }}>
                    You currently have <strong>{this.state.uncertifiedCount}</strong> uncertified timesheets.
                </p>
                <p style={{ marginBottom: 0 }}>
                    Please review your timesheets and follow up with your supervisor as soon as possible.
                </p>
            </div>
        );
    }
    render() {
        if (this.props.store.user && this.props.store.user.studentId > 0) {

            return (
                <main className="container">
                    {this.renderWarningCard()}
                    <div className="row">
                        <article className="col-md-7">
                            <h1>Summer Work Study Time Submission Instructions</h1>
                            <p><strong>Please Note:</strong> Timesheets are due by the end of the day on Friday of each week.</p>
                            {/* <p>For payroll purposes, you will be considered an employee of Temple University since Temple University will be providing the matching funds required for you to be paid through the federal work study program for the work you are doing this summer. </p> */}
                            <p>When submitting your time sheets please keep the following information and requirements in mind.</p>
                            <ul>
                                <li>
                                    You may only work within the summer work study period which begins on <strong>May 8th and ends August 25th</strong>.
                                    You cannot work prior to or after the summer work study period dates. If you submit time for any hours worked prior to completing Temple's payroll process, your pay may be subject to a monetary penalty by the university.
                                </li>
                                <li><strong>The hourly pay rate is $15.00</strong>. You will be paid only for the hours you submit on your weekly timesheet. You must stop working once you have earned the full amount of your summer work study award. It is your responsibility to keep track of how many hours you have worked. You can view your summer work study award amount on TUPortal and you can keep track of the hours you submit on the Time Submission System.</li>
                                <li>You may not work more than <strong>40 hours per week</strong>.</li>
                                <li>You must indicate at least <strong>1/2 hour for lunch</strong> for days in which you work 5 or more hours. <strong>Lunch is unpaid.</strong></li>
                                <li>You do not receive paid leave for holidays, jury duty, sick time, or vacation.</li>
                                <li>Go to the week for which you wish to enter time; enter your hours, make sure they are correct, then select <strong>Save and Review</strong>. After you review, click <strong>submit</strong> If you did not work for a week, please submit a blank timsesheet for the week that you did not work.</li>
                                <li>Adobe Sign will be used to collect the required signatures and transmit the timesheets. Once your time is recorded in the system, you will be sent an email with a link to sign the timesheet through AdobeSign. Please follow the steps below for you and your supervisor to sign the timesheet through AdobeSign:
                                    <ol>
                                        <li>Select signature field</li>
                                        <li>Sign the document electronically, then click "Apply"</li>
                                        <li>Click on "Click to Sign" at the bottom of the page</li>
                                        <li>Your supervisor will be sent an email with a unique URL and will be instructed to follow steps 1-3 listed above to electronically sign and submit your timesheet.</li>
                                    </ol>
                                </li>

                                <li>Your signed timesheet must be submitted weekly <strong>by the end of the day on Friday</strong> of each week. For example, if you have worked during the week of June 5th, you must submit the timesheet for those hours by the end of the working day on June 9th in order to ensure that you will receive your pay on time for each pay period. If your timesheet is submitted after the deadline for the current pay period, your pay cannot be issued until the next pay period.</li>
                                <li><strong>You must be signed up for payroll direct deposit</strong> through the University in order to receive matching funds from the law school. Your paycheck will be directly deposited into your account. You can sign up for direct deposit through Staff Tools on <a target="__blank" href="https://tuportal.temple.edu">TUPortal</a>.</li>
                                <li>It usually takes at least two weeks after submitting your first time sheet before you will receive your first paycheck.</li>
                                <li>Paychecks are generated every other Friday and will be disbursed via direct deposit.</li>
                            </ul>

                            <p style={{ color: "red" }}>Please make sure that you enter the correct hours on your timesheet. If you make a mistake, please notify your supervisor and our office immediately. Falsifying time is a violation of federal work study regulations and the law school honor code. Students who falsify time will be subject to law school disciplinary action.</p>

                            <p>Thank you for your cooperation.</p>
                            <p>Temple Law School Financial Aid Office</p>

                        </article>
                        <nav className="col-md-5">
                            <AccountBalancePanel store={this.props.store} />

                            <AccountSelectHyperlist
                                accountStatus="Locked"
                                store={this.props.store}
                            />

                            <AccountSelectHyperlist
                                accountStatus="Active"
                                store={this.props.store}
                            />

                            <AccountSelectHyperlist
                                accountStatus="Pending"
                                store={this.props.store}
                            />

                        </nav>
                    </div>
                </main>
            )
        }

        else {
            return (
                <div>
                    <p>We couldn't find an account associated with user. If you reached this page in error, please contact an adminstrator.</p>
                </div>
            )
        }
    }
}

const styles = {
    overlay: {
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0,0,0,0.45)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 9999
    },
    modal: {
        backgroundColor: "#fff",
        padding: "24px",
        borderRadius: "8px",
        maxWidth: "500px",
        width: "90%",
        boxShadow: "0 2px 12px rgba(0,0,0,0.25)"
    },
    buttonRow: {
        display: "flex",
        justifyContent: "flex-end",
        marginTop: "20px"
    }
};
export default withRouter(StudentHome)
//< SelectAccountWidget store = { props.store } />
